import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, contentTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { AppColors } from "resources/AppColors"

function DeleteContentDialog({ deleteContent }) {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteContent() {
    dispatch(deleteContent(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate(-1)
  }

  return (
    <CustomDialog
      title={contentTexts.DELETE_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {contentTexts.DELETE_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          data-cy="submit-delete-content-button"
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteContent}
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteContentDialog